"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentManagementQueryService = void 0;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var mappers_1 = require("../mappers");
var webhook_mapper_1 = require("../mappers/webhook-mapper");
var base_content_management_service_class_1 = require("./base-content-management-service.class");
var ContentManagementQueryService = /** @class */ (function (_super) {
    __extends(ContentManagementQueryService, _super);
    function ContentManagementQueryService(config, httpService, sdkInfo) {
        var _this = _super.call(this, config, httpService, sdkInfo) || this;
        _this.config = config;
        _this.httpService = httpService;
        _this.sdkInfo = sdkInfo;
        _this.defaultDelayBetweenRequests = 250;
        return _this;
    }
    ContentManagementQueryService.prototype.genericPostResponse = function (url, data, config) {
        return this.postResponse(url, data, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.genericMapper.mapGenericResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.genericPatchResponse = function (url, data, config) {
        return this.patchResponse(url, data, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.genericMapper.mapGenericResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.genericDeleteResponse = function (url, config) {
        return this.deleteResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.genericMapper.mapGenericResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.genericGetResponse = function (url, config) {
        return this.getResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.genericMapper.mapGenericResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.genericPutResponse = function (url, data, config) {
        return this.putResponse(url, data, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.genericMapper.mapGenericResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.getListAllResponse = function (data) {
        return this.getListAllResponseInternal({
            resolvedResponses: [],
            getResponse: data.getResponse,
            xContinuationToken: undefined,
            listQueryConfig: data.listQueryConfig
        }).pipe(operators_1.map(function (responses) {
            return data.allResponseFactory(responses.reduce(function (prev, current) {
                prev.push.apply(prev, current.data.items);
                return prev;
            }, []), responses);
        }));
    };
    ContentManagementQueryService.prototype.publishLanguageVariant = function (url, data, config) {
        return this.putResponse(url, data, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.workflowMapper.mapEmptyResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.createNewVersionOfLanguageVariant = function (url, config) {
        return this.putResponse(url, undefined, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.workflowMapper.mapEmptyResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.unpublishLanguageVariant = function (url, data, config) {
        return this.putResponse(url, data, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.workflowMapper.mapEmptyResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.cancelScheduledPublishingOfLanguageVariant = function (url, config) {
        return this.putResponse(url, undefined, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.workflowMapper.mapEmptyResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.cancelScheduledUnpublishingOfLanguageVariant = function (url, config) {
        return this.putResponse(url, undefined, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.workflowMapper.mapEmptyResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.changeWorkflowStepOfLanguageVariant = function (url, config) {
        return this.putResponse(url, undefined, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.workflowMapper.mapEmptyResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.listWorkflowSteps = function (url, config) {
        return this.getResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.workflowMapper.mapListWorkflowStepsResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.addContentType = function (url, data, config) {
        return this.postResponse(url, data, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.contentTypeMapper.mapAddContentTypeResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.viewContentTypeSnippet = function (url, config) {
        return this.getResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.contentTypeSnippetMapper.mapViewContentTypeSnippetResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.deleteContentTypeSnippet = function (url, config) {
        return this.deleteResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.contentTypeSnippetMapper.mapEmptyResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.addContentTypeSnippet = function (url, data, config) {
        return this.postResponse(url, data, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.contentTypeSnippetMapper.mapAddContentTypeSnippetResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.listContentTypeSnippets = function (url, config) {
        return this.getResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.contentTypeSnippetMapper.mapListingResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.projectInformation = function (url, config) {
        return this.getResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.projectMapper.mapProjectInformationResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.validateProjectContent = function (url, data, config) {
        return this.postResponse(url, data, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.projectMapper.mapValidateProjectContentResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.deleteContentType = function (url, config) {
        return this.deleteResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.contentTypeMapper.mapEmptyResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.modifyContentType = function (url, config, data) {
        return this.patchResponse(url, data, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.contentTypeMapper.mapModifyContentTypeResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.modifyTaxonomy = function (url, config, data) {
        return this.patchResponse(url, data, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.taxonomyMappper.mapModifyTaxonomyResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.modifyContentTypeSnippet = function (url, config, data) {
        return this.patchResponse(url, data, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.contentTypeSnippetMapper.mapModifyContentTypeSnippetResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.viewContentType = function (url, config) {
        return this.getResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.contentTypeMapper.mapViewContentTypeResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.listContentTypes = function (url, config) {
        return this.getResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.contentTypeMapper.mapListingResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.addTaxonomy = function (url, data, config) {
        return this.postResponse(url, data, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.taxonomyMappper.mapAddTaxonomyResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.deleteTaxonomy = function (url, config) {
        return this.deleteResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.taxonomyMappper.mapEmptyResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.getTaxonomy = function (url, config) {
        return this.getResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.taxonomyMappper.mapGetTaxonomyResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.listTaxonomies = function (url, config) {
        return this.getResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.taxonomyMappper.mapListingTaxonomysResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.deleteAsset = function (url, config) {
        return this.deleteResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.assetsMapper.mapEmptyResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.upsertAsset = function (url, data, config) {
        return this.putResponse(url, data, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.assetsMapper.mapUpsertAssetResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.addAsset = function (url, data, config) {
        return this.postResponse(url, data, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.assetsMapper.mapAddAssetResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.uploadBinaryFile = function (url, data, config) {
        return this.postResponse(url, data.binaryData, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.assetsMapper.mapUploadBinaryFileResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.viewAsset = function (url, config) {
        return this.getResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.assetsMapper.mapViewAssetResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.listAssets = function (url, config) {
        return this.getResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.assetsMapper.mapListingAssetsResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.listContentItems = function (url, config) {
        return this.getResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.contentItemsMapper.mapListingItemsResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.viewContentItem = function (url, config) {
        return this.getResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.contentItemsMapper.mapViewContentItemResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.addContentItem = function (url, data, config) {
        return this.postResponse(url, data, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.contentItemsMapper.mapAddContentItemResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.upsertContentItem = function (url, data, config) {
        return this.putResponse(url, data, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.contentItemsMapper.mapUpsertContentItemResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.updateContentItem = function (url, data, config) {
        return this.putResponse(url, data, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.contentItemsMapper.mapUpdateContentItemResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.deleteContentItem = function (url, config) {
        return this.deleteResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.contentItemsMapper.mapEmptyResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.deleteLanguageVariant = function (url, config) {
        return this.deleteResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.contentItemsMapper.mapEmptyResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.upsertLanguageVariant = function (url, elements, config) {
        return this.putResponse(url, {
            elements: elements
        }, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.languageVariantMapper.mapUpsertLanguageVariantResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.viewLanguageVariant = function (url, config) {
        return this.getResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.languageVariantMapper.mapViewLanguageVariantResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.listLanguageVariantsOfItem = function (url, config) {
        return this.getResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.languageVariantMapper.mapLanguageVariantsOfItemResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.listLanguageVariantsOfContentTypeWithComponents = function (url, config) {
        return this.getResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.languageVariantMapper.mapLanguageVariantsOfContentTypeWithComponentsResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.listLanguageVariantsOfContentType = function (url, config) {
        return this.getResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.languageVariantMapper.mapLanguageVariantsOfContentTypeResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.listLanguages = function (url, config) {
        return this.getResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.languageMapper.mapListLanguagesResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.viewLanguage = function (url, config) {
        return this.getResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.languageMapper.mapViewLanguageResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.addLanguage = function (url, config, data) {
        return this.postResponse(url, data, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.languageMapper.mapAddLanguageResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.modifyLanguage = function (url, config, data) {
        return this.patchResponse(url, data, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.languageMapper.mapModifyLanguageResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.listWebhooks = function (url, config) {
        return this.getResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return webhook_mapper_1.webhookMapper.mapWebhooksListResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.getWebhook = function (url, config) {
        return this.getResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return webhook_mapper_1.webhookMapper.mapGetWebhookResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.addWebhook = function (url, config, data) {
        return this.postResponse(url, data, {}, config).pipe(operators_1.map(function (response) {
            return webhook_mapper_1.webhookMapper.mapAddWebhookResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.enableWebhook = function (url, config) {
        return this.putResponse(url, {}, {}, config).pipe(operators_1.map(function (response) {
            return webhook_mapper_1.webhookMapper.mapEnableWebhookResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.disableWebhook = function (url, config) {
        return this.putResponse(url, {}, {}, config).pipe(operators_1.map(function (response) {
            return webhook_mapper_1.webhookMapper.mapDisableWebhookResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.deleteWebhook = function (url, config) {
        return this.deleteResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return webhook_mapper_1.webhookMapper.mapEmptyResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.listAssetFolders = function (url, config) {
        return this.getResponse(url, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.assetFolderMapper.mapListAssetFoldersResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.addAssetFolders = function (url, config, data) {
        return this.postResponse(url, data, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.assetFolderMapper.mapAddAssetFoldersResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.modifyAssetFolders = function (url, config, data) {
        return this.patchResponse(url, data, {}, config).pipe(operators_1.map(function (response) {
            return mappers_1.assetFolderMapper.mapModifyAssetFoldersResponse(response);
        }));
    };
    ContentManagementQueryService.prototype.getListAllResponseInternal = function (data) {
        var _this = this;
        var _a, _b;
        return data.getResponse(data.xContinuationToken).pipe(operators_1.delay((_b = (_a = data.listQueryConfig) === null || _a === void 0 ? void 0 : _a.delayBetweenRequests) !== null && _b !== void 0 ? _b : this.defaultDelayBetweenRequests), operators_1.flatMap(function (response) {
            var _a;
            data.resolvedResponses.push(response);
            if ((_a = data.listQueryConfig) === null || _a === void 0 ? void 0 : _a.responseFetched) {
                data.listQueryConfig.responseFetched(response, data.xContinuationToken);
            }
            if (response.data.pagination.continuationToken) {
                // recursively fetch next page data
                return _this.getListAllResponseInternal({
                    xContinuationToken: response.data.pagination.continuationToken,
                    getResponse: data.getResponse,
                    resolvedResponses: data.resolvedResponses
                });
            }
            return rxjs_1.of(undefined);
        }), operators_1.map(function () {
            return data.resolvedResponses;
        }));
    };
    return ContentManagementQueryService;
}(base_content_management_service_class_1.BaseContentManagementQueryService));
exports.ContentManagementQueryService = ContentManagementQueryService;
//# sourceMappingURL=content-management-query-service.class.js.map